import React from 'react';
import Navbar from '../molecule/Navbar';

class Layout extends React.Component {

    render () {
        return (
            <div>
                <Navbar />
            </div>
        )
    }
}

export default Layout;